import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import '@/plugins/apexcharts';
import router from './router';
import firebase from 'firebase';

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)

import VueGoogleCharts from 'vue-google-charts';
Vue.use(VueGoogleCharts)

var firebaseConfig = {
  apiKey: "AIzaSyCsV3V_ktVW1ia-sr-PX6SmTyGo1aLwnlU",
  authDomain: "waldock-my-life-pie.firebaseapp.com",
  databaseURL: "https://waldock-my-life-pie.firebaseio.com",
  projectId: "waldock-my-life-pie",
  storageBucket: "waldock-my-life-pie.appspot.com",
  messagingSenderId: "18672363916",
  appId: "1:18672363916:web:09bbc4046a3438f7f68ea9"
};

firebase.initializeApp(firebaseConfig);

import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')